module.exports = __webpack_public_path__ + "img/标准策略select.a553b34b.svg";